import { useHistory } from 'react-router-dom';
import { UUIHistoryState } from '../components/common/types';
import * as H from 'history';

export type UUIHistory = H.History<UUIHistoryState>;

export const useUUIHistory = (): UUIHistory => {
    const history = useHistory<UUIHistoryState>() as UUIHistory;
    return history;
};
